import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M19.477 11.227h-6.703V4.524a.773.773 0 1 0-1.546 0v6.703H4.525a.773.773 0 1 0 0 1.546h6.703v6.703a.773.773 0 1 0 1.546 0v-6.703h6.703a.773.773 0 1 0 0-1.546z"
}), 'Add');